import React, { useEffect, useState } from "react";
import {
  getAgentProfile,
} from "../services/v2/agentProfile";
import { useParams, useLocation } from "react-router-dom";
import BackButton from "@/components/Common/BackButton";
import { useNavigate } from "react-router-dom";
import { loggedInUser } from "../helpers/common";
import { pageURLs } from "@/constants";
import { useAppConfig } from "@/appConfig";
import { PageWrapper } from "@/components/PageWrapper";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import AgentBioHeader from "@/components/AgentBioHeader";
import AgentBioSections from "@/components/AgentBioSections";
import { BioLegalLinks } from "@/components/BioDisclosure";
import { gitchaBioUrl, useAgentBioLink } from "@/hooks/useAgentBioLink";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { recordBioContact } from "@/services/bioLeadService";
import { recordBioOpen } from "@/services/gitchaReachService";
import BioMessageSheet from "@/components/BioMessageSheet";
import AgentBioMissing from "@/components/AgentBioMissing";

const AgentInfo = () => {

  const params = useParams();
  const { slug } = params;
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = location.state?.fromSettings || location.state?.canGoBack;
  const [apiData, setData] = useState([]);
  const [missing, setMissing] = useState(null);
  const userId = loggedInUser();
  const currentUserId = userId?.userInfo?.userId ?? null;

  const { flags } = useAppConfig();
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const { opensGitcha } = useAgentBioLink();

  useEffect(() => {
    if (opensGitcha && slug) window.location.replace(gitchaBioUrl(slug));
  }, [opensGitcha, slug]);

  const getAgentInfo = async (inventoryId) => {
    setMissing(null);
    await getAgentProfile(inventoryId)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setData(responseResult?.data);
        if (response?.errorCode === 0 && responseResult?.data) {
        } else {
          setMissing("notFound");
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        setMissing(err?.response || err?.errorCode !== undefined ? "notFound" : "unreachable");
        console.log("Error", err);
      });
  };

  useEffect(() => {
    if (slug && !opensGitcha) {
      getAgentInfo(slug);
    }
  }, [slug, opensGitcha]);

  useEffect(() => {
    const ownerId = apiData?.UserId;
    if (!slug || !ownerId) return;
    if (currentUserId && Number(currentUserId) === Number(ownerId)) return;
    if (new URLSearchParams(location.search).get("self") === "1") return;
    const key = `gitcha-page-open:${slug}:${new Date().toISOString().slice(0, 10)}`;
    try {
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, "1");
    } catch {
      return;
    }
    Promise.resolve(recordBioOpen(slug, {})).catch(() => {});
  }, [slug, apiData?.UserId]);

  const handleNavigateToDetailPage = (slug) => navigate(`${pageURLs.wantAdDetails}/${slug}`);

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  const { redirectToBLSEnv } = useMLSAgentAtGitchaRedirect();


  const [composerOpen, setComposerOpen] = useState(false);

  const handleTrack = (body) => {
    if (!slug || (currentUserId && Number(currentUserId) === Number(apiData?.UserId))) return;
    Promise.resolve(recordBioContact(slug, body)).catch(() => {});
  };

  const handleNavigateToDirectMessage = () => {

    if (shouldRestrictAgent) {
      return redirectToBLSEnv({
        path: `${pageURLs.directMessages}?id=${apiData?.UserId}`,
        onGitchaEnvFallback: null,
      });
    }

    if (!userId) {
      return setComposerOpen(true);
    }

    navigate(`${pageURLs.directMessages}?id=${apiData?.UserId}`, {
      state: {
        agentName: apiData?.FirstName,
        agentId: apiData?.UserId,
        agentCompany: apiData?.Company,
        agentProfile: apiData?.Img,
        fromDM: true,
      },
    });
  };

  if (opensGitcha) return null;

  return (
    <>
      <PageWrapper>
        <div className={"agent-info-container"}>
          {canGoBack && <BackButton className="mb-24 d-inline-block" />}
          {missing ? (
            <AgentBioMissing unreachable={missing === "unreachable"} />
          ) : (
          <>
          <AgentBioHeader
            agent={apiData}
            isGitchaWebsite={isGitchaDefaultWebsite}
            proBadge={flags.proBadge}
            onDirectMessage={handleNavigateToDirectMessage}
            onTrack={handleTrack}
            onBuyerListingForm={() =>
              window.open(
                `${process.env.REACT_APP_BUYERLISTING_SERVICE_BASE_URL}/form/${params?.slug}`,
                "_blank",
              )
            }
          />

          <AgentBioSections
            agent={apiData}
            layout={apiData?.bioLayout}
            onOpen={handleNavigateToDetailPage}
            onTrack={handleTrack}
          />
          <BioLegalLinks agent={apiData} />
          <BioMessageSheet
            show={composerOpen}
            onHide={() => setComposerOpen(false)}
            slug={slug}
            agentFirstName={apiData?.FirstName}
          />
          </>
          )}

        </div>
      </PageWrapper>
    </>
  );
};

export default AgentInfo;
